import React from "react";

/**
 * Primenax brand mark — uses the OFFICIAL user-supplied logo
 * (red lion + PRIMENAX wordmark) on its native black background, which
 * matches the site bg (#050505) so it reads as a single unified mark.
 *
 * `mark` → lion-only crop (header / small areas)
 * `full` → full lockup with wordmark + tagline (footer / hero)
 */
export const PrimenaxLogo = ({ className = "", variant = "mark" }) => {
  if (variant === "full") {
    return (
      <img
        src="/brand/primenax-official-full.png"
        alt="Primenax — Be the Natural Selection"
        className={`h-20 md:h-28 w-auto select-none ${className}`}
        draggable={false}
        data-testid="primenax-logo-full"
      />
    );
  }
  return (
    <img
      src="/brand/primenax-official-full.png"
      alt="Primenax — Be the Natural Selection"
      className={`h-12 md:h-16 w-auto select-none ${className}`}
      draggable={false}
      data-testid="primenax-logo"
    />
  );
};

export default PrimenaxLogo;
